// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__37tpD","obliqueLineWrap":"membershipbadge_obliqueLineWrap__y5VRD","obliqueLine":"membershipbadge_obliqueLine__22jSM"};